<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton" data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title #title data-test="title" (click)="onTitleClick()">Orders</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary" class="ion-text-wrap">
        {{orders.length}} orders defined.
    </ion-list-header>

    <ion-list class="ion-padding">
        @for (order of orders; track $index) {
  <ion-item-sliding>
            <ion-item data-test="orderItem" detail="true" (click)="onOrderClick(order)" href="javascript:;">
                <ion-label>
                    <span class="line1">Order Number: {{order.header.orderId}}</span><br />
                    <span class="line2">Purchased On: {{order.header.createdDate.date |
                            myTimestamp : 'EEEE, MMMM do yyyy, hh:mm:ss a' }}
                    </span><br />
                    <span class="line2">Amount: {{order.header.total | myCurrency}}</span><br />
                    <span class="line2">{{order.header.description}}</span>
                </ion-label>
            </ion-item>
        </ion-item-sliding>
}
    </ion-list>
</ion-content>